import React, { useEffect, useCallback, useRef } from 'react';
import { PromoPropType } from '@propTypes';
import { useGTM } from '@hooks';
import styles from './styles/index.module.scss';

const MenuPromosItem = ({ promo }) => {
  const {
    campaign_uuid: id,
    redirection_url: url,
    creative_mobile: mobile = {},
    name,
  } = promo;
  const [pushToGTM] = useGTM();
  const bannerRef = useRef(null);

  const registerObserver = useCallback(
    data => {
      if (!bannerRef.current) return;

      const options = { threshold: 1.0 };
      const callback = ([entry], observer) => {
        if (entry.intersectionRatio === 1) {
          pushToGTM({
            event: 'display_campaign',
            campaign_id: data.campaign_uuid,
            campaign_name: data.name,
            space_slug: 'onglet_banner',
          });
          observer.disconnect();
        }
      };

      const observer = new IntersectionObserver(callback, options);
      observer.observe(bannerRef.current);
    },
    [pushToGTM],
  );

  useEffect(() => registerObserver(promo), [promo]);

  const onPromoClick = useCallback(() => {
    pushToGTM({
      event: 'click_campaign',
      campaign_id: id,
      campaign_name: name,
      space_slug: 'onglet_banner',
    });
  }, [pushToGTM]);

  return (
    <div className={styles.promos__item} ref={bannerRef}>
      <a
        href={url}
        onClick={onPromoClick}
        data-privatesale-id={id}
        data-privatesale-name={name}
      >
        <img alt={name} src={mobile.url} />
      </a>
    </div>
  );
};

MenuPromosItem.propTypes = {
  promo: PromoPropType.isRequired,
};

MenuPromosItem.displayName = 'MenuPromosItem';

export default MenuPromosItem;
